<template>
  <div class="remove_class">
    <el-dialog
      title="移出班级"
      :visible.sync="openDialog"
      width="50%"
      class="dialog_title"
      @close="closeDialog"
    >
      <el-row :gutter="15">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="24">
            <el-form-item label="移出班级：" prop="id">
              <el-radio-group v-model="form.id" size="medium">
                <el-radio
                  v-for="(item, index) in idOptions"
                  :key="index"
                  :label="item.value"
                  :disabled="item.disabled"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="原因："
              prop="deleted_remark"
              v-if="form.id == 2"
            >
              <el-input
                v-model="form.deleted_remark"
                placeholder="请输入原因"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <el-button @click="cancel" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {RemoveStudent} from '@/api/tearcher'
export default {
  data() {
    return {
      openDialog: false,
      form: {},
      id:"",
      idOptions: [
        {
          label: "非本班学员",
          value: 1,
        },
        {
          label: "其他",
          value: 2,
        },
      ],
      // 表单校验
      rules: {
        id: [
          {
            required: true,
            message: "移出班级不能为空",
            trigger: "change",
          },
        ],
        deleted_remark: [
          {
            required: true,
            message: "原因不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 取消按钮
    cancel() {
      this.openDialog = false;
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let setLeader = {};
          setLeader.id = this.id;
          if (this.form.deleted_remark) {
            setLeader.deleted_remark = this.form.deleted_remark;
          }
          RemoveStudent(setLeader)
            .then((response) => {
              if (response.error_code === 201) {
                this.messageTips("移除成功","success");
                this.openDialog = false;
                this.$emit("requestCommonFn");
              }
            })
            .catch((reason) => {
              console.log(reason);
            });
        }
      });
    },
    // 关闭dialog
    closeDialog() {
      this.form = {};
      // 重置表单
      this.resetForm("form");
    },
    // 操作dialog
    operationDialog(id) {
      this.openDialog = true;
      this.id = id;
    },
  },
};
</script>
 
<style lang = "less" scoped>
.remove_class {
    /deep/ .el-form{
        .el-input__inner{
            width: 100% !important;
        }
    }
}
</style>